// extracted by mini-css-extract-plugin
module.exports = {"overlay":"overlay--kqvZ8"};